import styles from './InputModal.module.scss';
import Button from '@shared/components/atoms/Button';

/**
 * InputModal 컴포넌트
 * - 텍스트 입력을 받는 모달 (반려 사유, 수정요청 사유 등)
 * - 배경 클릭 시 닫히지 않음 (closeOnOverlayClick=false)
 * - 확인/취소 버튼으로만 닫힘
 *
 * @param {boolean} isOpen 모달 열림 여부
 * @param {string} title 모달 제목
 * @param {string} value 입력값
 * @param {Function} onChange 입력값 변경 핸들러
 * @param {Function} onConfirm 확인 버튼 클릭 핸들러
 * @param {Function} onCancel 취소 버튼 클릭 핸들러
 * @param {string} placeholder 입력창 플레이스홀더
 * @param {number} maxLength 최대 글자수 (기본값 500)
 * @param {Function} onExceedMaxLength 붙여넣기로 최대 글자수 초과 시 콜백
 */
function InputModal({
  isOpen,
  title,
  value,
  onChange,
  onConfirm,
  onCancel,
  placeholder = '내용을 입력해주세요.',
  maxLength = 500,
  onExceedMaxLength,
}) {
  if (!isOpen) return null;

  // 붙여넣기 이벤트 핸들러 - 클립보드 데이터 직접 확인
  function handlePaste(e) {
    const pasteData = e.clipboardData?.getData('text') || '';
    const currentValue = value || '';

    // 선택 영역 계산 (선택된 텍스트는 대체됨)
    const target = e.target;
    const selectionStart = target.selectionStart || 0;
    const selectionEnd = target.selectionEnd || 0;

    // 붙여넣기 후 예상 텍스트
    const beforeSelection = currentValue.substring(0, selectionStart);
    const afterSelection = currentValue.substring(selectionEnd);
    const expectedValue = beforeSelection + pasteData + afterSelection;

    // 최대 글자수 초과 시
    if (expectedValue.length > maxLength) {
      e.preventDefault(); // 붙여넣기 차단
      if (onExceedMaxLength) {
        onExceedMaxLength();
      }
    }
  }

  // 텍스트 변경 핸들러 - 타이핑 시 제한
  function handleChange(e) {
    const newValue = e.target.value;

    // 최대 글자수 이하만 허용
    if (newValue.length <= maxLength) {
      onChange(newValue);
    }
    // 초과 시 무시 (타이핑의 경우 알럿 없이 차단)
  }

  const currentLength = value ? value.length : 0;

  return (
    <div className={styles.overlay} onClick={(e) => e.stopPropagation()}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <h2 className={styles.title}>{title}</h2>
        </div>

        <div className={styles.content}>
          <textarea
            className={styles.textarea}
            value={value}
            onChange={handleChange}
            onPaste={handlePaste}
            placeholder={placeholder}
            rows={5}
          />
          <div className={styles.charCounter}>
            <span className={currentLength >= maxLength ? styles.limitReached : ''}>
              {currentLength}
            </span>
            /{maxLength}자
          </div>
        </div>

        <div className={styles.footer}>
          <Button variant="default" onClick={onCancel} className={styles.button}>
            취소
          </Button>
          <Button variant="primary" onClick={onConfirm} className={styles.button}>
            확인
          </Button>
        </div>
      </div>
    </div>
  );
}

export default InputModal;
